import React, {useEffect, useState} from "react";
import {Form, FormikProps} from "formik";
import Button from "../../Elements/Button";
import useToastNotify from "../../../hook/useToastNotify";
import {IVideoProductSpecialAttributeData} from "../../../contracts/data/video_product";
import Input from "../../Elements/Form/Input";


const InnerAddSpecialAttributeToVideoProductForm = (props: FormikProps<IVideoProductSpecialAttributeData>) => {
    const {toastNotify} = useToastNotify()

    useEffect(() => {
        if(props?.status?.hasOwnProperty('result')){
            toastNotify(props.status?.result?.status, props.status?.result?.message)
        }
    }, [props.status])

    return (
        <React.Fragment>
            <Form>
                <div className={"w-full min-h-[150px]"}>
                    <Input name={"content"} label={"مقدار ویژگی"} placeholder={"مقدار ویژگی..."}
                           meta={props.getFieldMeta('content')} defaultValue={props.values?.content}/>
                </div>
                <div className={"text-right"}>
                    <Button title={props?.status?.formType === 'create' ? "افزودن ویژگی" : "ویرایش ویژگی"} isLoading={props.isSubmitting}/>
                </div>
            </Form>
        </React.Fragment>
    )
}

export default InnerAddSpecialAttributeToVideoProductForm